import actions from './actions';

const {
  GET_STORE_BEGIN, GET_STORE_SUCCESS, GET_STORE_FAILED,
  ADD_STORE_BEGIN, ADD_STORE_SUCCESS, ADD_STORE_FAILED,
  UPDATE_STORE_BEGIN, UPDATE_STORE_SUCCESS, UPDATE_STORE_FAILED,
  DELETE_STORE_BEGIN, DELETE_STORE_SUCCESS, DELETE_STORE_FAILED
} = actions;

const initState = {
  stores: [],
  total: 0,
  loading: false,
  error: null,
};


const StoreReducer = (state = initState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case GET_STORE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case GET_STORE_SUCCESS:
      return {
        ...state,
        stores: data.stores,
        total: data.total,
        loading: false,
      };
    case GET_STORE_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case ADD_STORE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case ADD_STORE_SUCCESS:
      return {
        ...state,
        total: state.total + 1,
        stores: data,
        loading: false,
      };
    case ADD_STORE_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case UPDATE_STORE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case UPDATE_STORE_SUCCESS:
      return {
        ...state,
        stores: data,
        loading: false,
      };
    case UPDATE_STORE_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    case DELETE_STORE_BEGIN:
      return {
        ...state,
        loading: true,
      };
    case DELETE_STORE_SUCCESS:
      return {
        ...state,
        total: state.total - 1,
        stores: data,
        loading: false,
      };
    case DELETE_STORE_FAILED:
      return {
        ...state,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};
export default StoreReducer;